import React, { Component, createRef } from 'react'

import styled from 'styled-components'
import { Mobile, Desktop } from '../../../media'
import { withTranslation } from 'react-i18next';
import { NavLink, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Moment from 'moment';

import { bindActionCreators } from 'redux'
import { actions as authenticationActions } from '../../../actions/authentication'
import { actions as employeeActions } from '../../../actions/employee'
import { actions as staticContentActions } from '../../../actions/static_content'
import { actions as configurationActions } from '../../../actions/configuration'
import { history } from '../../../store'

import AlertMessage from '../../../components/AlertMessage'
import Navigation from '../navigation'
import Logo from './Logo'
import UserInfoMenu from './UserInfoMenu'
import NotificationsArea from './NotificationsArea'
import employeeService, { isZooxEmployee } from '../../../services/Employee.service'

import ChangeLanguageDialog from './ChangeLanguageDialog'
import ImpersonateUserDialog from './ImpersonateUserDialog'
import { UserRoles } from '../../../constants'
import AboutDialog from './AboutDialog';

const HeaderContainer = styled.header`
`

const HeaderArea = styled.div`
  background: #303042;
  position: relative;

  &.impersonated {
    background: #650000;
  }
`

const UserInfoHeader = styled.div`
  height: 50px;
  box-shadow: 0 1px 0 0 #181821;
  width: 930px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    padding: 0 16px;
  }
`

const BrokerInfo = styled.div`
  height: 96px;
  width: 930px;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: 100%;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    height: 174px;
    padding: 0 16px;
  }
`

const BrokerInfoData = styled.div`
  height: 100%;
  width : 70%;
  float: left;

  @media (max-width: 768px) {
    width : 100%;
    clear: both;
    height: auto;
  }
`

const BrokerInfoLinks = styled.div`
  height: auto;
  width : 30%;
  float: right;
  text-align: right;
  padding-top: 27px;

  @media (max-width: 768px) {
    width : 100%;
    clear: both;
    height: auto;
    text-align: left;
    padding-top: 10px;
  }

  >a {
    font-family: Lato-Regular;
    font-size: 14px;
    color: #FFFFFF;
    line-height: 16px;
    display: block;
    margin-bottom: 10px;
  }
`

const CurrentBrokerTitle = styled.div`
  font-family: Lato-Regular;
  font-size: 12px;
  color: #BABABA;
  line-height: 16px;
  margin-top: 0px;
  padding-top: 16px;
`

const BrokerName = styled.div`
  font-family: Lato-Light;
  font-size: 24px;
  color: #FFFFFF;
  line-height: 28px;
  float:left;
`

const BrokerMessages = styled.ul`
  padding: 0;
  margin: 0;
  clear: both;
  list-style: none;

  > li {
    line-height: 22px;
    font-family: Lato-Regular;
    font-size: 14px;
    color: #BABABA;
    float: left;

    @media (max-width: 768px) {
      float: none;
    }
  }

  > li:before {
    content: "|";
    margin: 0 6px;

    @media (max-width: 768px) {
      content: "";
      margin: 0;
    }
  }

  > li:first-child:before {
    content: "";
    margin: 0;
  }
`

const H1Area = styled.div`
  width: 930px;
  padding: 0;
  display: block;
  margin: 10px auto 10px auto;

  // Mobile version.
  @media (max-width: 768px) {
      width: 100%;
      padding: 0;
      margin: 5px 0 5px 0;
  }

  > h1 {
      font-family: Lato-Light;
      font-size: 24px;
      font-weight: normal;

      color: #2B2B2B;
      line-height: 28px;
      margin: 0 0 7px 0;
  }
`

export class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {  changeLanguageDialogVisible: false,
                    impersonateUserDialogVisible: false,
                    aboutDialogVisible: false };
  }

  onUserMenuSelection = (value, summaryRef) => {
    if (value === 2) {
      this.props.actions.authentication.removeImpersonate((employeeId) => {
        this.props.actions.employee.unload()
        this.props.actions.configuration.unload()
        this.props.actions.static_content.unload()

        history.push(employeeId === '' ? '/impersonate' : '/dashboard');
      })
    }

    this.setState({
      changeLanguageDialogVisible: value === 0,
      impersonateUserDialogVisible: value === 1,
      aboutDialogVisible: value === 3
    })

    summaryRef.focus();
  }

  onCloseChangeLanguageDialog = () => {
    this.setState({ changeLanguageDialogVisible: false })
  }

  onCloseImpersonateUserDialog = () => {
    this.setState({ impersonateUserDialogVisible: false })
  }

  onCloseAboutDialog = () => {
    this.setState({ aboutDialogVisible: false })
  }

  componentDidMount(){
    window.document.documentElement.lang = this.props.employee.language.split('-')[0];
  }

  componentDidUpdate(){
    window.document.documentElement.lang = this.props.employee.language.split('-')[0];
  }

  render() {
    const { t, employee, location, messages } = this.props
    const locale = employee.language
    const next_vest = employee.summary.next_vest
    const vest_quantity = new Intl.NumberFormat(locale).format(next_vest ? next_vest.shares_vest : 0);
    const has_awards = employee.awards.length > 0
    let message = null
    if (messages && messages.length > 0){
      message = messages.at(-1)
    }

    return (
      <HeaderContainer>
        <span id='alert-messages-for-screen-readers' aria-live='polite' aria-relevant='all' style={{position: "absolute", top: -20}}>{message?.text}</span>
          <AlertMessage message={message}/>
        <HeaderArea className={employeeService.hasRole(employee.roles, UserRoles.IMPERSONATED) ? 'impersonated' : ''}>
          <div style={{ borderBottom: "1px solid transparent" }}>
            <UserInfoHeader>
              <Logo />
              <UserInfoMenu onUserMenuSelection={this.onUserMenuSelection.bind(this)} />
            </UserInfoHeader>
          </div>
          <BrokerInfo>
            <BrokerInfoData>
              {employee.broker && (
                <div>
                  <CurrentBrokerTitle>{t('Header.CurrentBrokerLabel')}</CurrentBrokerTitle>
                  <div>
                    <BrokerName>{employee.broker.name}</BrokerName>
                  </div>
                </div>
              )}
              <BrokerMessages>
                { !employeeService.isBrokerChoiceNone(employee) &&
                <li>{employee.w8_w9_message}</li>
                }
                {has_awards && next_vest &&
                  <li>{t('Header.NextVestInfo', { vest_quantity: vest_quantity, vest_date: next_vest && Moment(next_vest.next_vest_date).format('ll') })}</li>
                }

              </BrokerMessages>
            </BrokerInfoData>
            <BrokerInfoLinks>
              {employee.broker &&
                <a href={employeeService.getEmployeeBrokerUrl(employee)} target="_blank">{t(`Header.GoToBrokerLink`, { broker_name: employee.broker && employee.broker.name })}</a>
              }

              {!employeeService.hasRole(employee.roles, UserRoles.BROKER_CHOICE_NONE) && employeeService.showAvailableBrokers(employee) && (
                <NavLink to="/broker" className="view-available-brokers-link">{t(`Header.AvailableBrokersLink`)}</NavLink>
              )}
            </BrokerInfoLinks>
          </BrokerInfo>
        </HeaderArea>
        {employee.notifications.length > 0 &&
          <NotificationsArea pathname={location.pathname} />
        }
        <Desktop>
          <Navigation />
        </Desktop>
        <H1Area>
          <h1 id="main-h1">Employee Stock Portal At a glance</h1>
        </H1Area>
        <ChangeLanguageDialog visible={this.state.changeLanguageDialogVisible} onCloseDialog={this.onCloseChangeLanguageDialog} />
        <ImpersonateUserDialog visible={this.state.impersonateUserDialogVisible} onCloseDialog={this.onCloseImpersonateUserDialog} />
        <AboutDialog visible={this.state.aboutDialogVisible} onCloseDialog={this.onCloseAboutDialog} />
      </HeaderContainer>
    )
  }
}

const mapState = state => ({
  employee: state.employee,
  auth: state.auth,
  messages: state.flashMessage.messages
})

const mapDispatchToProps = dispatch => ({
  actions: {
    authentication: bindActionCreators(authenticationActions, dispatch),
    employee: bindActionCreators(employeeActions, dispatch),
    static_content: bindActionCreators(staticContentActions, dispatch),
    configuration: bindActionCreators(configurationActions, dispatch),
  }
})

export default withRouter(connect(mapState, mapDispatchToProps)(withTranslation('translations')(Header)))
